// Préférences du shell V2, sans dépendance au shell lui-même : le squelette de
// démarrage (bundle principal) les lit avant que le chunk du shell n'arrive.
// Préférence de repli de la barre desktop (décision « L2 rétractable »,
// 2026-08-25) : l'état replié/déployé vaut pour toute l'application et
// survit à la navigation comme au rechargement. Même idiome de stockage que
// les préférences du menu (NavigationMenu), clé distincte car la portée est
// le shell, pas le contenu du menu.
const SHELL_PREFERENCES_KEY = "akongo.welfare.v2.shell";
const ENTITY_PANEL_PREFERENCES_KEY = "akongo.welfare.v2.entityPanel";
const DEFAULT_SHELL_PREFERENCES = Object.freeze({ navigationCollapsed: false });
const DEFAULT_ENTITY_PANEL_PREFERENCES = Object.freeze({ collapsed: false });

export const defaultShellStorage = () => (
  typeof window !== "undefined" ? window.localStorage : null
);

export const readShellPreferences = (storage = defaultShellStorage()) => {
  try {
    const raw = storage?.getItem?.(SHELL_PREFERENCES_KEY);
    if (!raw) return DEFAULT_SHELL_PREFERENCES;
    const parsed = JSON.parse(raw);
    return {
      navigationCollapsed: parsed?.navigationCollapsed === true,
    };
  } catch (_) {
    return DEFAULT_SHELL_PREFERENCES;
  }
};

export const readEntityPanelPreferences = (storage = defaultShellStorage()) => {
  try {
    const raw = storage?.getItem?.(ENTITY_PANEL_PREFERENCES_KEY);
    if (raw) return { collapsed: JSON.parse(raw)?.collapsed === true };

    // One-time compatibility with the first L2 implementation, which stored
    // both rails under the global shell key. The next panel toggle writes the
    // dedicated preference without losing an existing user choice.
    const legacyRaw = storage?.getItem?.(SHELL_PREFERENCES_KEY);
    if (!legacyRaw) return DEFAULT_ENTITY_PANEL_PREFERENCES;
    return { collapsed: JSON.parse(legacyRaw)?.entityPanelCollapsed === true };
  } catch (_) {
    return DEFAULT_ENTITY_PANEL_PREFERENCES;
  }
};

export const writeShellPreferences = (storage, preferences) => {
  try {
    storage?.setItem?.(SHELL_PREFERENCES_KEY, JSON.stringify(preferences));
  } catch (_) {
    // Une préférence qui ne peut pas être persistée reste valable pour la session.
  }
};

export const writeEntityPanelPreferences = (storage, preferences) => {
  try {
    storage?.setItem?.(ENTITY_PANEL_PREFERENCES_KEY, JSON.stringify(preferences));
  } catch (_) {
    // The panel remains usable for the current session when storage fails.
  }
};
